// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'open';

export const Component = () => (
  <>
    <path d='M10.824 6.413c.187 0 .45.038.656.243a.842.842 0 0 1 .234.504l.01.153c0 .187-.038.45-.244.656s-.469.243-.656.243H5.3v11.951h12.927v-5.488c0-.187.038-.45.243-.655.205-.205.468-.244.656-.244l.154.009c.162.02.349.08.503.235a.802.802 0 0 1 .212.4l.032.032v5.894c0 .466-.165.855-.482 1.172a1.596 1.596 0 0 1-1.172.482H5.154c-.466 0-.855-.165-1.172-.482a1.596 1.596 0 0 1-.482-1.172V8.067c0-.466.165-.855.482-1.172a1.596 1.596 0 0 1 1.172-.482z' />
    <path d='M20.6 4c.188 0 .451.038.657.243a.843.843 0 0 1 .234.504l.009.153v1.305-.001 4.587c-.001.187-.039.45-.244.655a.845.845 0 0 1-.503.235l-.153.01c-.189 0-.452-.04-.657-.245-.205-.205-.243-.468-.243-.655V7.103l-8.061 8.06-.022.022-.027.013-.051.026a3.523 3.523 0 0 1-.19.092.708.708 0 0 1-.186.062l-.118.011a.936.936 0 0 1-.674-.261.894.894 0 0 1-.247-.5l-.014-.174a.877.877 0 0 1 .266-.633l8.02-8.021H14.71c-.188 0-.45-.039-.656-.244a.842.842 0 0 1-.234-.504l-.01-.152c0-.188.038-.451.244-.657.206-.205.469-.243.656-.243z' />
  </>
);

export const viewBox = '0 0 25 25';
